import type { HTMLAttributes, ReactNode } from 'react';
import type { JobState } from '../tokens/tokens';
import './Badge.css';

export type BadgeTone = 'neutral' | 'accent' | 'danger' | 'success' | 'warning' | 'staff';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  /** A job lifecycle state colours the badge from the state palette. */
  state?: JobState;
  tone?: BadgeTone;
  children: ReactNode;
}

export const jobStateLabel: Record<JobState, string> = {
  setup: 'Setup',
  teaching: 'Teaching',
  supervised: 'Supervised',
  automatic: 'Automatic',
  paused: 'Paused',
  archived: 'Archived',
};

export function Badge({
  state,
  tone = 'neutral',
  className,
  children,
  ...rest
}: BadgeProps): ReactNode {
  const classes = [
    'pui-badge',
    state ? `pui-badge--state-${state}` : `pui-badge--${tone}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <span className={classes} {...rest}>
      {children}
    </span>
  );
}

/** The one-word state chip that is the biggest thing on a job card. */
export function JobStateBadge({ state }: { state: JobState }): ReactNode {
  return <Badge state={state}>{jobStateLabel[state]}</Badge>;
}
